export const PROCESS_CLEAR = "PROCESS_CLEAR";
export const PROCESS_START = "START";
export const PROCESS_ERROR = "ERROR";
export const PROCESS_RESET = "RESET";
export const PROCESS_SUCCESS = "SUCCESS";
export const PROCESS_COMPLETE = "COMPLETE";

export const APP_INITIALIZATION_PROCESS = "APP_INITIALIZATION_PROCESS";
export const APP_INITIALIZATION_START = "APP_INITIALIZATION_START";
